import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg12 from "../../assets/img/12.png";
import projectimage14 from "../../assets/img/p14.png";
let cardClass = "Card3";

const PreviousCard14 = () => {
    return (
        <Card className={cardClass} bg="dark">
              {/* <Card.Title><h2>Analysis of high time resolution historical data of the European electricity system</h2></Card.Title> */}
              <Card.Img variant="top" src={projectimage14} />

              <Card.Body>
                <Card.Text>
                  <img className="img2" src={projImg12} />{" "}
                  <p className="text7">Attila Aszódi </p>
                  <br />
                  <p className="text8">
                    Professor, Dean
                    <br /> Institute of Nuclear Techniques, BME
                  </p>
                </Card.Text>
                <ShowMoreText lines={1}>
                  <div>
                    The project will be co-supervised by Bence Biró. <br />
                    In this project, students will analyze hourly resolution
                    data of the European Association for the Cooperation of
                    Transmission System Operators (ENTSO-E). Students will use
                    advanced statistical and machine learning tools to
                    investigate the following research questions:
                    <br />
                    Processing of load change events of conventional power
                    plants (nuclear, coal-fired, natural gas-fired, etc.)
                    <br />
                    Investigating the relationship between power decrease and
                    increase events and electricity consumption
                    <br />
                    Investigating the relationship between load change events of
                    conventional power plants and weather-dependent renewable
                    energy production
                    <br />
                    <br />
                    Related literature:{" "}
                    <ul>
                      <li>
                        Mayer, M. J., Biró, B., Szücs, B., & Aszódi, A. (2023).
                        Probabilistic modeling of future electricity systems
                        with high renewable energy penetration using machine
                        learning. <span className="text9"> Applied Energy </span>,
                        336, 120801.
                      </li>
                      <li>
                        Aszódi, A., Biró, B., Adorján, L., Dobos, Á. C., Illés,
                        G., Tóth, N. K., ... & Zsiborás, Z. T. (2021).
                        Comparative analysis of national energy strategies of 19
                        European countries in light of the green deal’s
                        objectives.{" "}
                        <span className="text9">
                          {" "}
                          Energy Conversion and Management{" "}
                        </span>
                        : X, 12, 100136.
                      </li>
                      <li>
                        Hirth, L., Mühlenpfordt, J., & Bulkeley, M. (2018). The
                        ENTSO-E Transparency Platform–A review of Europe’s most
                        ambitious electricity data platform.
                        <span className="text9"> Applied Energy </span>, 225,
                        1054-1067.
                      </li>
                    </ul>
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
};

export default PreviousCard14;
